"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUsersStatusesSchema = exports.UpdateUserStatusSchema = exports.DailyStreakPatchBody = void 0;
const zod_1 = require("zod");
const types_1 = require("../../types");
exports.DailyStreakPatchBody = types_1.DailyStreak.partial();
exports.UpdateUserStatusSchema = zod_1.z.object({
    updatedStatus: types_1.UserStatusEnum,
    reason: types_1.UserStatusAdminReasonEnum,
    message: zod_1.z.string().optional(),
});
exports.UpdateUsersStatusesSchema = exports.UpdateUserStatusSchema.extend({
    userIds: zod_1.z.array(zod_1.z.string()),
});
